import { Toaster } from '@/components/customer-ui/toaster'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import CustomerAppRouter from './pages/customer-app/router'
import '@/i18n'
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6'
import { ThemeProvider } from '@/components/theme-provider'
import FormDirtyProvider from '@/stores/form-dirty-provider'
import { ToastContainer } from 'react-toastify'
import {
  trackingSentryMutation,
  trackingSentryQueries
} from '@/configs/tanstack-config'
import './pages/customer-app/ev-journey/styles.css'
import { Toaster as ToasterSonner } from '@/components/customer-ui/sonner'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      throwOnError: (_error) => {
        return false
      }
    }
  },
  mutationCache: trackingSentryMutation(),
  queryCache: trackingSentryQueries()
})

const customerApp = document.getElementById('customer-app')
if (customerApp != null) {
  createRoot(customerApp).render(
    <StrictMode>
      <ThemeProvider defaultTheme='light' storageKey='customer-theme'>
        <FormDirtyProvider>
          <QueryClientProvider client={queryClient}>
            <NuqsAdapter>
              <ToasterSonner />
              <ToastContainer />
              <CustomerAppRouter />
              <Toaster />
            </NuqsAdapter>
          </QueryClientProvider>
        </FormDirtyProvider>
      </ThemeProvider>
    </StrictMode>
  )
}
